/**
 * Turkiz Press — Main JavaScript Entry Point
 *
 * Imports and initializes all component modules.
 * Compiled to dist/js/main.min.js via `npm run build:js`
 *
 * @package TurkizPress
 * @since   2.0.0
 */

// ── Module Imports ───────────────────────────────────────────────────────────
import { init as initNavigation } from "./components/navigation.js";
import { init as initInfoCards } from "./components/info-cards.js";
import { init as initSidebar } from "./components/sidebar.js";

// ── Content Protection (capture phase — runs before any other handler) ───────
if (!document.body.classList.contains("logged-in")) {
  const blockMsg = "Tilos a tartalmunk másolása. (Contenido protegido)";

  ["copy", "cut"].forEach((evt) => {
    document.addEventListener(
      evt,
      (e) => {
        e.preventDefault();
        e.stopPropagation();
        try {
          if (e.clipboardData) {
            e.clipboardData.setData("text/plain", blockMsg);
          }
        } catch {
          /* clipboard overwrite failed, copy still blocked */
        }
      },
      true,
    );
  });

  document.addEventListener("contextmenu", (e) => e.preventDefault(), true);
}

// ── Initialize ───────────────────────────────────────────────────────────────
document.addEventListener("DOMContentLoaded", () => {
  initNavigation();
  initInfoCards();
  initSidebar();
});
